import handleLoading from './loading';
import addAuthorization from './authorization';

const interceptors = [
    handleLoading,
    addAuthorization
];

export default config => {
    const finalConfig = interceptors.reduce((currConfig, interceptor) => {
        return { ...currConfig, ...interceptor(currConfig) };
    }, config);

    return finalConfig;
};